export const setBaseUrl = () => {
	const hostname = window.location.hostname;
	const href = window.location.href;

	const isLocalhost =
		hostname === "localhost" ||
		hostname === "127.0.0.1" ||
		hostname === "0.0.0.0" ||
		href.includes("dev");

	if (isLocalhost) {
		// Use localhost for the API when accessed via 127.0.0.1/0.0.0.0 to avoid CORS mismatches
		// in dev environments where the API only whitelists http://localhost:3000.
		const apiHost =
			hostname === "127.0.0.1" || hostname === "0.0.0.0"
				? "localhost"
				: hostname;

		localStorage.setItem("baseUrl", `http://${apiHost}:5149`);
		localStorage.setItem("clientUrl", `http://${hostname}:3000`);
		return;
	} else if (href.includes("uat")) {
		localStorage.setItem(
			"baseUrl",
			"https://safetywiseapi-modern-uat.azurewebsites.net"
		);
		localStorage.setItem("clientUrl", "https://app-uat.fortherecord.pro");
		return;
	} else {
		localStorage.setItem("baseUrl", "https://apinew.fortherecord.pro");
		localStorage.setItem("clientUrl", "https://app.fortherecord.pro");
	}
};

export const getBaseUrl = () => {
	const hostname = window.location.hostname;
	const href = window.location.href;
	const isLocalhost =
		hostname === "localhost" ||
		hostname === "127.0.0.1" ||
		hostname === "0.0.0.0" ||
		href.includes("dev");
	const isUat = href.includes("uat");

	let baseUrl = localStorage.getItem("baseUrl");

	// Localhost/dev pointing at any remote host, a null string, or the legacy port (50575).
	const isStaleLocalhost =
		isLocalhost &&
		baseUrl &&
		(baseUrl.includes("fortherecord.pro") ||
			baseUrl.includes("azurewebsites.net") ||
			baseUrl.includes("null") ||
			baseUrl.includes(":50575"));

	// UAT environment still pointing at the pre-migration UAT endpoint.
	const isStaleUat =
		isUat && baseUrl && baseUrl.includes("safetywiseapiuat.azurewebsites.net");

	// Production environment still pointing at the pre-migration production endpoint.
	// Use a negative guard so "apinew.fortherecord.pro" is not incorrectly matched
	// as a substring of the old "api.fortherecord.pro" pattern.
	const isStaleProd =
		!isLocalhost &&
		!isUat &&
		baseUrl &&
		baseUrl.includes("api.fortherecord.pro") &&
		!baseUrl.includes("apinew.fortherecord.pro");

	if (!baseUrl || isStaleLocalhost || isStaleUat || isStaleProd) {
		setBaseUrl();
		baseUrl = localStorage.getItem("baseUrl");
	}
	return baseUrl;
};

export const getOrganisationBaseUrl = (stateValue) => {
	const currentOrganisation = stateValue.organisations.currentOrganisation;
	let organisationId;
	
	// Handle both string and object organization ID formats
	if (typeof currentOrganisation === 'string') {
		organisationId = currentOrganisation;
	} else if (currentOrganisation && currentOrganisation.id) {
		organisationId = currentOrganisation.id;
	} else {
		console.error("Invalid organization ID format in getOrganisationBaseUrl");
		organisationId = currentOrganisation; // fallback to whatever we have
	}
	
	return `${getBaseUrl()}/api/${organisationId}`;
};

export const getOrganisationBaseUrlByGuid = (organisationGUID) => {
	return `${getBaseUrl()}/api/${organisationGUID}`;
};

export const getWebsiteBaseUrl = () => {
	let baseUrl = localStorage.getItem("baseWebsiteUrl");
	return baseUrl;
};

export const setWebsiteBaseUrl = () => {
	localStorage.setItem("baseWebsiteUrl", "https://fortherecord.pro"); // This should always point to the fortherecord.pro website
};

export const getClientUrl = () => {
	let clientUrl = localStorage.getItem("clientUrl");
	return clientUrl;
};

export const getReCaptchaSiteKey = () => {
	return "6LcyLnIaAAAAAKMonBLqOqoTTCjnNw0VKQ0MMSo7";
};
